export const animDefaults = {
  animPeakEnabled: 0,
  animPeakCentre: 0.6,
  animPeakAmplitude: 0.15,
  animPeakSpeed: 0.4,
  animPeakStagger: 0.12,
  animMoveEnabled: 0,
  animMoveSpeed: 0.1,
  animTime: 0,
}

export function tick(state, time) {
  if (!state.animPeakEnabled && !state.animMoveEnabled) return false
  state.animTime = time * 0.001
  return true
}
